import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export function StoreDetailStreamRedirect() {
  const { storeName, streamKey } = useParams<{ storeName: string; streamKey: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams({
      mode: 'stream',
      stream: streamKey || '',
      store: storeName || '',
    });
    navigate(`/explorer?${params.toString()}`, { replace: true });
  }, [storeName, streamKey, navigate]);

  return null;
}
